import { render } from "./ChatbotMessages.vue?vue&type=template&id=158e46ef&scoped=true&ts=true"
import script from "./ChatbotMessages.vue?vue&type=script&lang=ts"
export * from "./ChatbotMessages.vue?vue&type=script&lang=ts"

import "./ChatbotMessages.vue?vue&type=style&index=0&id=158e46ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158e46ef"]])

export default __exports__